import type { OrderFormValues } from '../types/portfolio';

export type ValidationErrors = Partial<Record<keyof OrderFormValues | 'files' | 'spam', string>>;

const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const maxFileSize = 10 * 1024 * 1024;

export function validateOrderForm(values: OrderFormValues, files: File[], startedAt: number): ValidationErrors {
  const errors: ValidationErrors = {};
  const elapsed = Date.now() - startedAt;

  if (values.honeypot) errors.spam = 'Spam detected.';
  if (elapsed < 2500) errors.spam = 'Please take a moment before submitting.';
  if (!values.name.trim()) errors.name = 'Please enter your name.';
  if (!emailPattern.test(values.email)) errors.email = 'Please enter a valid email address.';
  if (!values.handle.trim()) errors.handle = 'Please add your Telegram or Discord handle.';
  if (!values.workType) errors.workType = 'Please select the type of work.';
  if (!values.category.trim()) errors.category = 'Please specify the project category.';
  if (!values.budget.trim()) errors.budget = 'Please specify the budget.';
  if (!values.deadline) errors.deadline = 'Please select a deadline.';
  if (values.description.trim().length < 30) errors.description = 'Please describe the task in at least 30 characters.';
  if (values.features.length === 0) errors.features = 'Please select at least one feature.';

  const oversized = files.find((file) => file.size > maxFileSize);
  if (oversized) errors.files = `File ${oversized.name} is larger than 10MB.`;

  return errors;
}

export function hasValidationErrors(errors: ValidationErrors) {
  return Object.keys(errors).length > 0;
}
